import { useQuery } from '@tanstack/react-query';
import { getStats } from './api'; // Importation de la fonction asynchrone
import { Discipline } from './enum';
import { Statistics } from './type';

const useGetStats = (hippodrome: string, price: number, discipline: Discipline, heureDepart: number) => {
    return useQuery<Statistics, Error>({
        queryKey: ['stats', `${heureDepart}`], // Clé unique pour cette requête
        queryFn: () => getStats(hippodrome, price, discipline, heureDepart), // Fonction de récupération
        staleTime: 1000 * 60 * 60 * 1, // Les données sont fraîches pendant 1 heure
        retry: 2, // Réessaie jusqu'à 2 fois en cas d'échec
        refetchOnWindowFocus: false, // Ne recharge pas automatiquement les données lors du retour sur la fenêtre,
        enabled: heureDepart > 0
    });
};

export default useGetStats;
